/* eslint-disable no-plusplus */
export const spliceArray = (array: Array<any>, chunkSize: number) => {
  const list = [];
  if (!array) return [];

  for (let i = 0; i < array.length; i += chunkSize) {
    list.push(array.slice(i, i + chunkSize));
    // do whatever
  }
  return list;
};
